var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"cols":_vm.extent}},[_c('pagelet',_vm._b({on:{"refresh":function($event){return _vm.$emit('refresh')},"perform":function (opts) { return _vm.$emit('perform', opts); }}},'pagelet',_vm.$props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }